import React, { useEffect, useLayoutEffect, useRef } from "react";
import Navigation from "../components/Navigation";
import harmonyBlured from "../images/harmonyBlured.png";
import Main from "../components/Main";
import History from "../components/History";
import SplitterImage from "../components/SplitImage";
import Flagmans from "../components/Flagmans";
import Products from "../components/Products";
import BuyBlock from "../components/BuyBlock";
import Footer from "../components/Footer";
import { checkAndSetStats } from "../helpers/helpers";
import SEO from "../components/SEO";

function Harmony() {
    const doesStatsSent = useRef(false);

    useLayoutEffect(() => {
        document.body.style.backgroundColor = "#DAD7DD";
        window.scrollTo({
            top: 0,
            behavior: "smooth",
        });
    }, []);

    useEffect(() => {
        if (!doesStatsSent.current) {
            checkAndSetStats("harmonyPage");
            doesStatsSent.current = true;
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    return (
        <div className="bg-harmony">
            <SEO
                title="Колекція Harmony"
                description="Harmony — гармонійна колекція ювелірних виробів від TSATSKY. Елегантні прикраси, що поєднують класику та сучасний дизайн."
                url="/harmony"
                collection={{ name: "Harmony", description: "Гармонійна колекція ювелірних виробів" }}
            />
            <Navigation showBack backTo="/" variant="light" />
            <div className="harmony_main_wrapper lg:bg-center">
                <Main
                    path="harmony"
                    logoImage={"https://i.ibb.co/fYHkZV40/harmony-1.png"}
                    firstTitleLine={"Унікальна коллекція від"}
                    textColor="text-black"
                    logoClassNames="my-6"
                    logoAlt="harmony Logo"
                    buttonClassNames="harmony-button"
                    borderStyles="border-harmonyDark"
                    defaultImage={harmonyBlured}
                />
            </div>

            <div className="bg-harmonyDark">
                <History
                    path="harmony"
                    containerClassNames="bg-harmony text-black"
                    defaultImage={harmonyBlured}
                />
                <SplitterImage borderStyles="border-harmonyDark shadow-bottom" />

                <Flagmans containerClassNames="text-black bg-harmony" />
                <Products
                    path="harmony"
                    containerClassNames="text-black bg-harmony"
                    productTextStyles={`text-black`}
                    productArticleStyles={`text-black`}
                    buttonStyles="bg-harmonyDark hover:bg-harmonyDarkHover text-white"
                    defaultImage={harmonyBlured}
                />

                <BuyBlock
                    buttonClassNames={"bg-harmonyDark"}
                    buttonTextClassNames={"text-harmony"}
                    containerClassNames="text-black bg-harmony py-4"
                />
                <Footer
                    containerClassNames={"bg-harmonyDark text-harmony"}
                    isDark
                />
            </div>
        </div>
    );
}

export default Harmony;
